import React, { useState, useRef, useEffect, useContext } from "react";

import { webLoadingFalse, webNavigate } from "../../services/navigate.service";
import CloseIcon from "../../images/CloseIcon";

import BackIcon from "../../images/BackIcon";
import ArrowRightIcon from "../../images/ArrowRightIcon";

import {
  getPurchases,
  updateStatusPurchases,
} from "../../services/purchases.services";

import {
  extractValues,
  updateUrlParams,
} from "../../validation/ValidationInput";
import UploadIconV2 from "../../images/UploadIconV2";
import { useResponsive } from "../../hook/useResponsive";
import PurchaseIcon from "../../images/PurchaseIcon";
import EditIconV2 from "../../images/EditIconV2";
import DeleteIconV2 from "../../images/DeleteIconV2";
import TagStatus from "../../components/TagStatus";
import { ConfirmSheet } from "../../components/mobile";
import { showApiError } from "../../services/apiError";
import {
  ListColumn,
  ListQuery,
  ListRowAction,
  ListScreen,
  ListScreenHandle,
  TEXT_MUTED,
  cells,
  formatMoney,
} from "../../components/list";

interface PurchaseRow {
  id: string;
  invoiceNumber?: string | null;
  createdAt: string;
  client?: { companyName?: string } | null;
  location?: { name?: string }[] | null;
  assets?: { categoryName?: string }[] | null;
  purchaseDetail?: { amount: string }[];
  status?: { statusName?: string } | null;
}

interface Category {
  id: string;
  code: string;
  name: string;
  children: CategoryChildren[];
}
interface CategoryChildren {
  id: string;
  code: string;
  name: string;
}
/** dd/MM/yyyy HH:mm in local time. */
const formatDateTime = (value: string | null | undefined) => {
  const d = new Date(value ?? "");
  if (!value || Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** Tabs keep their label on one line; the row scrolls instead. */
const TAB_STYLE: React.CSSProperties = { flex: "none", whiteSpace: "nowrap" };

declare global {
  interface Window {
    languageContext: any;
    modulesContext: any;
    noContext: any;
  }
}

const Purchases = () => {
  const preLanguage = localStorage.getItem("language");
  const [language, setLanguage] = useState<any>(null);
  const [total, setTotal] = useState<any>({});
  const companyId: string = localStorage.getItem("companyId") || "";
  const [showSave, setShowSave] = useState<boolean>(true);
  const [formValues, setFormValues] = useState<any>();
  const [showDelete, setShowDelete] = useState<boolean>(false);
  // Read before the list mounts so `key={tab}` does not remount it on load.
  const [tab, setTab] = useState<string>(() => {
    const filterParams: any = extractValues(location.search.split("&"));
    return filterParams.tab ? filterParams.tab : "all";
  });
  const tabRef = useRef<string>(tab);
  tabRef.current = tab;
  const [showAutomatic, setShowAutomatic] = useState<boolean>(false);
  const { isMobile, isTouchLayout } = useResponsive();
  const [categoryPurchase, setCategoryPurchase] = useState("");
  const [subCategoryPurchase, setSubCategoryPurchase] = useState("");
  const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false);
  const [isSubCategoryDropdownOpen, setIsSubCategoryDropdownOpen] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const categoryRef = useRef<HTMLDivElement>(null);
  const subCategoryRef = useRef<HTMLDivElement>(null);
  const [listCategory, setListStatus] = useState<Category[]>([
    {
      id: "1",
      code: "Draft",
      name: "Draft",
      children: [
        {
          id: "1",
          code: "Local purchase",
          name: "Local purchase",
        },
        {
          id: "2",
          code: "Expenses",
          name: "Expenses",
        },
        {
          id: "3",
          code: "Utilities",
          name: "Utilities",
        },
      ],
    },
    {
      id: "2",
      code: "Sent",
      name: "Sent",
      children: [
        {
          id: "1",
          code: "Local purchase",
          name: "Local purchase",
        },
        {
          id: "2",
          code: "Expenses",
          name: "Expenses",
        },
        {
          id: "3",
          code: "Utilities",
          name: "Utilities",
        },
      ],
    },
    {
      id: "3",
      code: "Incomplete",
      name: "Incomplete",
      children: [
        {
          id: "1",
          code: "Local purchase",
          name: "Local purchase",
        },
        {
          id: "2",
          code: "Expenses",
          name: "Expenses",
        },
        {
          id: "3",
          code: "Utilities",
          name: "Utilities",
        },
      ],
    },
  ]);
  // Lấy category đã chọn
  const [expandedCategoryId, setExpandedCategoryId] = useState<string | null>(
    null,
  );
  const selectedCategory = listCategory.find(cat => cat.name === categoryPurchase);
  // Lấy danh sách subcategories của category đã chọn
  const subCategories = selectedCategory?.children || [];
  const [idDelete, setIdDelete] = useState<any>({});
  const [fileName, setFileName] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const listRef = useRef<ListScreenHandle>(null);
  const inforTable: any = {
    img: <PurchaseIcon />,
    title:
      language && language?.["No purchase yet"]
        ? language?.["No purchase yet"]
        : "No purchase yet",
    path: "/purchases/new",
    desc:
      language &&
        language?.["Start by adding new manual or automatic purchase."]
        ? language?.["Start by adding new manual or automatic purchase."]
        : "Start by adding new manual or automatic purchase.",
    titleCreate:
      language && language?.["New Purchase"]
        ? language?.["New Purchase"]
        : "New Purchase",
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key === "f" && searchInputRef.current) {
      event.preventDefault();
      searchInputRef.current.focus();
      searchInputRef.current.select();
    }
  };
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        categoryRef.current &&
        !categoryRef.current.contains(event.target as Node)
      ) {
        setIsCategoryDropdownOpen(false);
      }
      if (subCategoryRef.current && !subCategoryRef.current.contains(event.target as Node)) {
        setIsSubCategoryDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  // Back / Forward on this page: re-read ?tab; `key={tab}` remounts the list.
  useEffect(() => {
    const path = location.pathname;
    const handlePopState = () => {
      if (location.pathname !== path) return;
      const filterParams: any = extractValues(location.search.split("&"));
      setTab(filterParams.tab ? filterParams.tab : "all");
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  /** One page of the active tab; the search box maps onto `searchValue` (invoice number). The response also carries the tab counts. */
  const fetchPurchases = async (query: ListQuery) => {
    webLoadingFalse();
    const response: any = await getPurchases(
      query.page,
      query.limit,
      query.search.trim(),
      companyId,
      tabRef.current,
    );
    setTotal(response?.data);
    return {
      rows: (response?.data?.purchases ?? []) as PurchaseRow[],
      count: response?.data?.count ?? 0,
    };
  };

  const goToPurchase = (id: string) => webNavigate("/" + preLanguage + "/purchases/" + id);
  const totalOf = (row: PurchaseRow): number =>
    (row.purchaseDetail ?? []).reduce((acc: number, val: any) => acc + Number(val.amount), 0);
  const statusOf = (row: PurchaseRow): string => row.status?.statusName ?? "";

  const handleShowDelete = (row: PurchaseRow) => {
    // Capture the supplier so the confirmation names which purchase is affected.
    setShowDelete(true);
    setIdDelete({
      id: row.id,
      seller: row.client?.companyName ?? "",
    });
  };
  const handleDeletePurchase = async () => {
    try {
      const response = await updateStatusPurchases(idDelete.id, {
        type: idDelete.type,
      });
    } catch (error) {
      console.error("Error loading terms:", error);
      showApiError(error, { language });
    } finally {
      listRef.current?.reload();
      setShowDelete(false);
    }
  };

  const handleCategorySelect = (categoryId: string, categoryName: string) => {
    setSelectedCategoryId(categoryId);
    setCategoryPurchase(categoryName);
    setIsCategoryDropdownOpen(false);
    setSubCategoryPurchase(''); //
  };

  const handleSubCategorySelect = (subCategoryId: string, subCategoryName: string) => {
    setSubCategoryPurchase(subCategoryName);
    setIsSubCategoryDropdownOpen(false);
  };
  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    setFileName(file.name);
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    setFileName(file.name);
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  /** Switching tabs goes back to page 1 but keeps the search; `key={tab}` remounts the list so it re-reads the URL. */
  const handleChangeTab = (value: string) => {
    if (value === tabRef.current) {
      listRef.current?.reload();
      return;
    }
    const filterParams: any = extractValues(location.search.split("&"));
    setTab(value);
    webNavigate(
      updateUrlParams({
        searchValue: filterParams.search,
        tab: value,
        page: 1,
        limit: filterParams.limit,
      }),
    );
  };

  /* ---------------- List kit configuration ---------------- */

  const columns: ListColumn<PurchaseRow>[] = [
    {
      key: "rowNumber",
      label: "#",
      width: 56,
      minWidth: 44,
      value: (_r, ctx) => (ctx.page - 1) * ctx.limit + ctx.index + 1,
      mobile: "hidden",
    },
    {
      key: "seller",
      label: "Seller",
      width: 200,
      minWidth: 120,
      hideable: false,
      value: r => r.client?.companyName || "",
      render: cells.primary(r => r.client?.companyName || "/"),
      mobile: "title",
      onClick: r => goToPurchase(String(r.id)),
    },
    {
      key: "createdAt",
      label: "Date",
      width: 140,
      minWidth: 120,
      value: r => formatDateTime(r.createdAt),
      render: r => (
        <div
          className="font-inter"
          style={{ fontSize: "13px", color: TEXT_MUTED, fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {formatDateTime(r.createdAt)}
        </div>
      ),
      mobile: "subtitle",
    },
    { key: "location", label: "Location", width: 140, minWidth: 96, value: r => r.location?.[0]?.name || "/", mobile: "sheet" },
    { key: "category", label: "Category", width: 140, minWidth: 96, value: r => r.assets?.[0]?.categoryName || "/", mobile: "sheet" },
    {
      key: "invoiceNumber",
      label: "Invoice No",
      width: 140,
      minWidth: 96,
      value: r => r.invoiceNumber || "",
      render: cells.text(r => r.invoiceNumber || "/"),
      mobile: "subtitle",
      onClick: r => goToPurchase(String(r.id)),
    },
    {
      key: "total",
      label: "Total",
      width: 110,
      minWidth: 88,
      align: "right",
      value: r => formatMoney(totalOf(r)),
      render: cells.money(r => totalOf(r), true),
      mobile: "trailing",
    },
    {
      key: "status",
      label: "Status",
      width: 130,
      minWidth: 110,
      value: r => statusOf(r),
      render: (r, ctx) => <TagStatus value={statusOf(r)} label={ctx.language?.[statusOf(r)]} />,
      mobile: "trailing",
    },
  ];

  const rowActions: ListRowAction<PurchaseRow>[] = [
    {
      key: "edit",
      label: "Edit",
      icon: <EditIconV2 />,
      sheetIcon: "sales",
      onRun: r => goToPurchase(String(r.id)),
    },
    {
      key: "delete",
      label: "Delete",
      icon: <DeleteIconV2 />,
      sheetIcon: "close",
      danger: true,
      onRun: r => handleShowDelete(r),
    },
  ];

  const deleteTitle =
    language && language?.["Delete Purchases?"]
      ? language?.["Delete Purchases?"]
      : "Delete Purchases";
  const deleteMessage = (
    <>
      {language &&
        language?.[
        "You will permanently cancel the purchase to be reviewed."
        ]
        ? language?.[
        "You will permanently cancel the purchase to be reviewed."
        ]
        : "You will permanently cancel the purchase to be reviewed."}
      {idDelete?.seller ? (
        <span style={{ color: "#222525", fontWeight: 600 }}>
          {" "}
          {idDelete.seller}
        </span>
      ) : null}
    </>
  );
  const cancelLabel =
    language && language?.["Cancel"] ? language?.["Cancel"] : "Cancel";
  const deleteLabel =
    language && language?.["Delete"] ? language?.["Delete"] : "Delete";

  return (
    <>
      <div
        style={{
          position: "relative",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflowY: isTouchLayout ? "auto" : undefined,
          paddingBottom: isTouchLayout ? "24px" : undefined,
        }}
      >
        <div
          className="lg:flex items-center justify-between"
          style={{ margin: "0px 0px 24px 0px" }}
        >
          <div className="space-y-2">
            <p
              style={{ color: "#222525" }}
              className="text-[24px] leading-[130%] font-medium font-inter"
            >
              {language && language?.["Purchases"]
                ? language?.["Purchases"]
                : "Purchases"}
            </p>
            <p
              style={{ color: "#6A7878", fontWeight: "500" }}
              className="text-[14px] leading-[130%] font-normal text-gray-700"
            >
              {language && language?.["Manage and create new purchases"]
                ? language?.["Manage and create new purchases"]
                : "Manage and create new purchases"}
              .
            </p>
          </div>
          <div
            className="flex items-center gap-x-3"
            style={{
              marginTop: isTouchLayout ? "20px" : "",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <div
              className="cursor-pointer flex items-center justify-center"
              style={{
                gap: "8px",
                padding: "10px 24px",
                backgroundColor: "white",
                color: "#0F7679",
                borderRadius: "30px",
                border: "1px solid #0F7679",
              }}
              onClick={(e: any) => {
                setShowAutomatic(true);
              }}
            >
              <p className="text-[14px] leading-[130%] font-medium font-inter">
                {language && language?.["Automatic purchase"]
                  ? language?.["Automatic purchase"]
                  : "Automatic purchase"}
              </p>
            </div>
            <div
              className="cursor-pointer flex items-center justify-center"
              style={{
                gap: "8px",
                padding: "10px 24px",
                backgroundColor: "#0F7679",
                borderRadius: "30px",
              }}
              onClick={() => {
                webNavigate("/" + preLanguage + "/purchases/new");
              }}
            >
              <p
                style={{ color: "#FFFFFF" }}
                className="text-[14px] leading-[130%] font-medium font-inter"
              >
                {language && language?.["Manual purchase"]
                  ? language?.["Manual purchase"]
                  : "Manual purchase"}
              </p>
            </div>
          </div>
        </div>
        <div
          className="flex items-center relative"
          role="tablist"
          style={{
            // Inset rule instead of a border: the row scrolls sideways on a narrow phone.
            boxShadow: "inset 0 -1px 0 #EBF0F0",
            overflowX: "auto",
            scrollbarWidth: "none",
            flex: "none",
          }}
        >
          <p
            className="text-[14px] font-inter hover_text_purchase duration-300 leading-[21px] font-medium cursor-pointer relative flex items-center"
            role="tab"
            aria-selected={tab === "all"}
            onClick={() => {
              handleChangeTab("all");
            }}
            style={
              tab === "all"
                ? {
                  ...TAB_STYLE,
                  marginRight: "24px",
                  color: "#0D5759",
                  borderBottom: "2px solid #0D5759",
                  paddingBottom: "8px",
                }
                : {
                  ...TAB_STYLE,
                  marginRight: "24px",
                  color: "#6A7878",
                  paddingBottom: "8px",
                }
            }
          >
            {language && language?.["All"] ? language?.["All"] : "All"}
            <div
              className="flex items-center justify-center rounded-full font-inter text-main leading-[18px] text-center"
              style={{
                width: "24px",
                height: "24px",
                fontSize: "12px",
                fontWeight: "600",
                backgroundColor: tab === "all" ? "#0F7679" : "#F3F3F3",
                marginLeft: "4px",
                color: tab === "all" ? "white" : "#6A7878",
              }}
            >
              {total?.countAll}
            </div>
          </p>

          <p
            className="text-[14px] font-inter hover_text_purchase duration-300 leading-[21px] font-medium cursor-pointer relative flex items-center"
            role="tab"
            aria-selected={tab === "inprogress"}
            onClick={() => {
              handleChangeTab("inprogress");
            }}
            style={
              tab === "inprogress"
                ? {
                  ...TAB_STYLE,
                  marginRight: "24px",
                  color: "#0D5759",
                  borderBottom: "2px solid #0D5759",
                  paddingBottom: "8px",
                }
                : {
                  ...TAB_STYLE,
                  marginRight: "24px",
                  color: "#6A7878",
                  paddingBottom: "8px",
                }
            }
          >
            {language && language?.["In progress"]
              ? language?.["In progress"]
              : "In progress"}
            <div
              className="flex items-center justify-center rounded-full font-inter text-main leading-[18px] text-center"
              style={{
                width: "24px",
                height: "24px",
                fontSize: "12px",
                fontWeight: "600",
                backgroundColor: tab === "inprogress" ? "#0F7679" : "#F3F3F3",
                marginLeft: "4px",
                color: tab === "inprogress" ? "white" : "#6A7878",
              }}
            >
              {total?.countInProgress}
            </div>
          </p>

          <p
            className="text-[14px] font-inter hover_text_purchase duration-300 leading-[21px] font-medium cursor-pointer relative flex items-center"
            role="tab"
            aria-selected={tab === "reviewed"}
            onClick={() => {
              handleChangeTab("reviewed");
            }}
            style={
              tab === "reviewed"
                ? {
                  ...TAB_STYLE,
                  color: "#0D5759",
                  borderBottom: "2px solid #0D5759",
                  paddingBottom: "8px",
                }
                : { ...TAB_STYLE, color: "#6A7878", paddingBottom: "8px" }
            }
          >
            {language && language?.["To be reviewed"]
              ? language?.["To be reviewed"]
              : "To be reviewed"}
            <div
              className="flex items-center justify-center rounded-full font-inter text-main leading-[18px] text-center"
              style={{
                width: "24px",
                height: "24px",
                fontSize: "12px",
                fontWeight: "600",
                backgroundColor: tab === "reviewed" ? "#0F7679" : "#F3F3F3",
                marginLeft: "4px",
                color: tab === "reviewed" ? "white" : "#6A7878",
              }}
            >
              {total?.countInReview}
            </div>
          </p>
        </div>
        <ListScreen
          key={tab}
          ref={listRef}
          language={language}
          columns={columns}
          fetchRows={fetchPurchases}
          searchPlaceholder="Search invoice number"
          searchInputRef={searchInputRef}
          rowActions={rowActions}
          countNoun="purchases"
          emptyState={inforTable}
          extraUrlParams={{ tab }}
        />

        <div
          className={`fixed inset-0 flex items-end justify-end duration-300`}
          style={{
            height: "100vh",
            width: "100vw",
            backgroundColor: "#22252552",
            top: 0,
            left: 0,
            opacity: showAutomatic ? 1 : 0,
            zIndex: "200",
            pointerEvents: showAutomatic ? "auto" : "none",
          }}
        >
          <div
            style={{
              borderTopLeftRadius: "20px",
              borderBottomLeftRadius: "20px",
              padding: "24px",
              width: !isMobile ? "30%" : "90%",
              height: "100%",
              transform: showAutomatic ? "translateX(0)" : "translateX(100%)",
              transition: "transform 0.3s ease-in-out",
            }}
            className="shadow_panel bg-white"
          >
            <div className="flex items-ceter justify-between">
              <p
                style={{ fontSize: "20px" }}
                className="font-inter font-semibold leading-[24px] text-main"
              >
                {language && language?.["Automatic Purchase"]
                  ? language?.["Automatic Purchase"]
                  : "Automatic Purchase"}{" "}
              </p>
              <div
                onClick={() => {
                  setShowAutomatic(false);
                }}
                className="flex items-center justify-center cursor-pointer"
                style={{ width: "24px", height: "24px" }}
              >
                <CloseIcon />
              </div>
            </div>
            <div className="w-full h-full relative">
              <div style={{ marginTop: "24px" }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] leading-[20px] font-inter"
                    style={{ color: "#222525", fontWeight: "500" }}
                  >
                    {language && language?.["Category"]
                      ? language?.["Category"]
                      : "Category"}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: "#BA0E13" }}
                  >
                    {language && language?.["*"] ? language?.["*"] : "*"}
                  </p>
                </div>
                <div
                  className=""
                  style={{ marginTop: "6px", borderRadius: "6px" }}
                >
                  <div className="w-full">
                    <div className="relative" ref={categoryRef}>
                      <input
                        type="text"
                        value={categoryPurchase}
                        onClick={() => setIsCategoryDropdownOpen(true)}
                        readOnly
                        placeholder="Select category"
                        className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-transparent w-full cursor-pointer"
                      />

                      {isCategoryDropdownOpen && (
                        <div className="absolute z-[100] w-full mt-1 bg-white border border-[#EBEBED] rounded-lg p-1 shadow-lg max-h-[240px] overflow-y-auto">
                          {listCategory.map((category) => (
                            <div
                              key={category.id}
                              className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-200 rounded px-3 py-2"
                              onClick={() => handleCategorySelect(category.id, category.name)}
                            >
                              {category.name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {selectedCategoryId && (listCategory.find(cat => cat.id === selectedCategoryId)?.children.length ?? 0) > 0 && (
                    <div className="space-y-2" style={{ marginTop: "20px" }}>
                      <div className="flex items-center">
                        <p
                          className="text-[14px] leading-[20px] font-inter"
                          style={{ color: "#222525", fontWeight: "500" }}
                        >
                          {language && language?.["Operational costs"]
                            ? language?.["Operational costs"]
                            : "Operational costs"}
                        </p>
                        <p
                          className="text-[14px] font-inter leading-[20px] font-medium"
                          style={{ color: "#BA0E13" }}
                        >
                          {language && language?.["*"] ? language?.["*"] : "*"}
                        </p>
                      </div>
                      <div className="w-full">
                        <div className="relative" ref={subCategoryRef}>
                          <input
                            type="text"
                            value={subCategoryPurchase}
                            onClick={() => setIsSubCategoryDropdownOpen(true)}
                            readOnly
                            placeholder="Select subcategory"
                            className="text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-lg outline-none focus-none bg-transparent w-full cursor-pointer"
                          />

                          {isSubCategoryDropdownOpen && (
                            <div className="absolute z-[100] w-full mt-1 bg-white border border-[#EBEBED] rounded-lg p-1 shadow-lg max-h-[240px] overflow-y-auto">
                              {listCategory
                                .find(cat => cat.id === selectedCategoryId)
                                ?.children.map((subCategory) => (
                                  <div
                                    key={subCategory.id}
                                    className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-200 rounded px-3 py-2"
                                    onClick={() => handleSubCategorySelect(subCategory.id, subCategory.name)}
                                  >
                                    {subCategory.name}
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    className="w-full flex items-center justify-center"
                    style={{
                      marginTop: "20px",
                      padding: "32px 24px",
                      backgroundColor: "#FFFFFF",
                      border: `1px dashed ${isDragging ? "#3AC0C4" : "#DBE4E4"}`,
                      borderRadius: "12px",
                    }}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                  >
                    <div className="space-y-2 text-center">
                      <div className="flex items-center justify-center">
                        <UploadIconV2 />
                      </div>
                      <label
                        htmlFor="fileInput"
                        className="text-[14px] font-inter  font-semibold leading-[18px] cursor-pointer"
                        style={{ color: "#0F7679", marginTop: "8px" }}
                      >
                        {language && language?.["Upload CSV File"]
                          ? language?.["Upload CSV File"]
                          : "Upload CSV File"}
                        <span
                          style={{ color: "#4A5353" }}
                          className="text-[14px] leading-[20px] font-inter"
                        >
                          {fileName
                            ? `File: ${fileName}`
                            : " or drag & drop here"}
                        </span>
                      </label>

                      <p
                        style={{ fontSize: "12px", color: "#6A7878" }}
                        className="leading-[22px] font-inter"
                      >
                        {language && language?.["PNG, JPG up to 10MB"]
                          ? language?.["PNG, JPG up to 10MB"]
                          : "PNG, JPG up to 10MB"}
                      </p>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        id="fileInput"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="absolute flex items-center gap-x-3"
                style={{ bottom: "48px", right: "0px" }}
              >
                <div
                  onClick={() => {
                    setShowAutomatic(false);
                  }}
                  className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center"
                  style={{
                    width: "fit-content",
                    borderRadius: "40px",
                    padding: "10px 24px",
                    border: "1px solid #C9D7D8",
                    color: "#222525",
                    fontWeight: "500",
                  }}
                >
                  {language && language?.["Cancel"]
                    ? language?.["Cancel"]
                    : "Cancel"}
                </div>
                <div
                  onClick={() => {
                    setShowAutomatic(false);
                  }}
                  className="cursor-pointer text-[14px] leading-[22px] font-inter flex items-center justify-center"
                  style={{
                    width: "fit-content",
                    borderRadius: "40px",
                    padding: "10px 24px",
                    backgroundColor: "#0F7679",
                    color: "#FFFFFF",
                    fontWeight: "500",
                  }}
                >
                  {language && language?.["Save"] ? language?.["Save"] : "Save"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isTouchLayout ? (
        <ConfirmSheet
          open={showDelete}
          title={deleteTitle}
          message={deleteMessage}
          confirmLabel={deleteLabel}
          cancelLabel={cancelLabel}
          onConfirm={handleDeletePurchase}
          onCancel={() => setShowDelete(false)}
        />
      ) : (
        <div
          className={`absolute w-full h-full top-0 left-0 flex items-center justify-center px-4 ${showDelete ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
          style={{
            backgroundColor: "#22252552",
            zIndex: "200",
            transition: "opacity 0.3s ease, visibility 0.3s ease",
            width: "100vw",
            height: "100vh",
            left: 0,
            top: 0,
          }}
        >
          <div
            className={`transform transition-transform duration-300 ease-in-out ${showDelete ? "translate-y-0" : "translate-y-4 opacity-0"}`}
            style={{
              padding: "24px",
              borderRadius: "24px",
              backgroundColor: "#FFFFFF",
              width: "530px",
              transition: "transform 0.3s ease, opacity 0.3s ease",
            }}
          >
            <div className="flex items-center justify-between">
              <p
                style={{ fontSize: "20px", color: "#222525" }}
                className="font-semibold font-inter leading-[24px]"
              >
                {deleteTitle}
              </p>
              <div
                onClick={() => setShowDelete(false)}
                className="flex items-center justify-center cursor-pointer"
                style={{
                  width: "24px",
                  height: "24px",
                }}
              >
                <CloseIcon />
              </div>
            </div>
            <div className="flex items-center justify-between">
              <p
                className="text-[14px] font-inter leading-[24px]"
                style={{ color: "#6A7878" }}
              >
                {deleteMessage}
              </p>
            </div>
            <div
              className="flex items-center justify-end"
              style={{ marginTop: "24px", gap: "12px" }}
            >
              <div
                onClick={() => setShowDelete(false)}
                className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
                style={{
                  borderRadius: "30px",
                  padding: "10px 24px",
                  border: "1px solid #C9D7D8",
                  color: "#222525",
                }}
              >
                {cancelLabel}
              </div>
              <div
                onClick={handleDeletePurchase}
                className="cursor-pointer text-[14px] leading-[22px] font-inter font-medium"
                style={{
                  borderRadius: "30px",
                  padding: "10px 24px",
                  backgroundColor: "#BA0E13",
                  color: "#FFFFFF",
                }}
              >
                {deleteLabel}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Purchases;
